import React from 'react'
import type { FundingProduct } from '@frontend/components/agromarket/core/access-control'
import { EColor } from '@frontend/pole-ui/lib/common/constants'
import { InfoFillIcon } from '@frontend/pole-ui/lib/components/Icon/svg/InfoFillIcon'
import omit from 'lodash/omit'
import type { CreateFundingRequestPrivateDto } from '@/api/kubik/credit'
import type { IApplyingFinancingOfferRequestBody } from '@/logic/financing/interfaces'
import { MFO_PRODUCTS } from './constants'
import { messages } from './messages'
import type { TFinancingOfferModalStepsAdapter } from './types'

export const defaultFinancingOfferStepsAdapter: TFinancingOfferModalStepsAdapter = (steps, context, onClickConsult, isLoading = false) =>
  steps.map(step => ({
    ...step,
    fields: step.fields.map(field => {
      const controlledField = { ...field }

      if (field.fieldType === 'checkbox' || field.fieldType === 'policyAgreement')
        return omit(controlledField, ['activeControlStyle', 'borderColorStyle', 'markColor'])

      if (field.fieldType === 'infoText')
        return {
          ...field,
          className: 'loanProductOrderForm__infoText',
          iconProps: {
            className: 'loanProductOrderForm__infoIcon',
            style: { color: EColor.GREEN },
            component: <InfoFillIcon />,
          },
        }

      if (field.name === 'loanAmount.value') return { ...controlledField, shouldBeTouchedBeforeError: true }

      return controlledField
    }),
    calcButton: {
      modifiers: ['outline-gray', 'full-width-mobile'],
      textId: messages.actions.requestConsult,
      onClick: onClickConsult,
    },
    submitButton: {
      ...step.submitButton,
      modifiers: ['green', 'full-width-mobile'],
      loaderProps: {
        isVisible: isLoading,
      },
    },
  }))

export const formattedRequestBody = (
  formValues: IApplyingFinancingOfferRequestBody,
  isMFOProduct: boolean,
): CreateFundingRequestPrivateDto => {
  const baseRequestBody: CreateFundingRequestPrivateDto = {
    phone: formValues.phone,
    email: formValues.email,
    agreement: formValues.agreement,
    city: formValues.city,
    comment: formValues.comment,
    loanAmount: formValues.loanAmount,
    productIds: [formValues.productId as string],
    fiasCode: formValues.fiasCode,
    cropsArea: formValues.cropsArea,
    regionCode: formValues.regionCode,
    grossHarvest: formValues.grossHarvest,
    contactPersonPosition: formValues.contactPersonPosition,
    desiredAdvancePaymentDate: formValues.desiredAdvancePaymentDate,
  }

  if (isMFOProduct) {
    return { ...baseRequestBody, regionCode: formValues.regions }
  }

  return baseRequestBody
}

export const isMFOProducts = (productId: FundingProduct) => MFO_PRODUCTS.includes(productId)
